var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var CustomerFeedbackForm = function () {
            function CustomerFeedbackForm(wrapperElement) {
                _classCallCheck(this, CustomerFeedbackForm);

                // контейнер
                this.$wrapper = $(wrapperElement);

                // можно ли показывать форму
                this.canShowForm = true;

                // экран формы с полями ввода, с которого был осуществлён переход на экран с отрицательным результатом сабмита
                this.$currentFieldsetSection = null;

                // ИД таймера, ответственного за промежуточный показ экрана формы с положительным результатом сабмита
                this.successTimerId = 0;

                this.initElements();
                this.initForm();
                this.bindEventHandlers();
                this.bindSearchFormEventHandlers();
            }

            // привязать обработчики событий


            _createClass(CustomerFeedbackForm, [{
                key: "bindEventHandlers",
                value: function bindEventHandlers() {
                    var self = this;

                    this.$buttonFeedback.on('click', function (e) {
                        e.preventDefault();
                        self.sendFeedback();
                        return false;
                    });

                    this.$buttonCallback.on('click', function (e) {
                        e.preventDefault();
                        self.sendCallback();
                        return false;
                    });

                    this.$buttonRetry.on('click', function (e) {
                        e.preventDefault();
                        self.showSection(self.$currentFieldsetSection);
                        return false;
                    });

                    this.$form.on('submit', function (e) {
                        e.preventDefault();
                        return false;
                    });

                    this.$text.on('input', function () {
                        $(this).removeClass('has-error');
                    });

                    this.$phone.on('input', function () {
                        $(this).closest('.input-control.control-text').removeClass('has-error');
                    });
                }

                // привязать обработчики событий search.*

            }, {
                key: "bindSearchFormEventHandlers",
                value: function bindSearchFormEventHandlers() {
                    var self = this;

                    $(window)
                    // hide when search starts
                    .on('search.startMain', function (e, searchReq) {
                        // скрыть
                        self.$wrapper.addClass('hidden');
                        // сбросить форму к исходному состоянию, чтобы при новом поиске можно было отправить новый отзыв
                        self.initForm();

                        self.canShowForm = true;
                    })
                    // show when any hotel exists
                    .on('search.chunk', function (e, searchReq, chunk) {
                        var tours = searchReq.lastChunkTours.getAll();
                        if (tours.length && self.canShowForm) {
                            // искусственно откладываем показ формы, ибо в данный момент отели могут ещё не зарендериться
                            setTimeout(function () {
                                return self.$wrapper.removeClass('hidden');
                            }, 1111);
                            // для других chunks в текущем продолжающемся поиске не показывать уже сокрытую форму
                            self.canShowForm = false;
                        }
                    })
                    // show when search ends
                    .on('search.end', function (e, searchReq) {
                        self.$wrapper.removeClass('hidden');
                        self.canShowForm = true;
                    });
                }
            }, {
                key: "freezeForm",
                value: function freezeForm() {
                    this.$form.addClass('state-loading').find(':input, :button').attr('disabled', 'disabled');
                }

                // инициализировать элементы формы

            }, {
                key: "initElements",
                value: function initElements() {
                    // форма
                    this.$form = this.$wrapper.find('.customer-feedback-form');

                    this.initSectionElements();
                    this.initTextInputElements();
                    this.initButtonElements();
                }

                // инициализировать экраны формы

            }, {
                key: "initSectionElements",
                value: function initSectionElements() {
                    // экраны формы
                    this.$sections = this.$form.find('.form-section');

                    // экраны формы с полями ввода
                    var $fieldsetSections = this.$sections.filter('.section-type-fieldset');
                    // экран формы для отправки текста отзыва
                    this.$feedback = $fieldsetSections.filter('.section-content-feedback');
                    // экран формы для отправки номера телефона
                    this.$callback = $fieldsetSections.filter('.section-content-callback');

                    // экраны формы с результатами сабмитов
                    var $resultSections = this.$sections.filter('.section-type-result');
                    // экран формы с отрицательным результатом сабмита
                    this.$fail = $resultSections.filter('.section-result-fail');
                    // экран формы с положительным результатом сабмита
                    this.$success = $resultSections.filter('.section-result-success');
                }

                // инициализировать текстовые поля ввода

            }, {
                key: "initTextInputElements",
                value: function initTextInputElements() {
                    // текст отзыва
                    this.$text = this.$feedback.find('[name="text"]');
                    // номер телефона
                    this.$phone = this.$callback.find('[name="phone"]');
                }

                // инициализировать кнопки

            }, {
                key: "initButtonElements",
                value: function initButtonElements() {
                    // кнопка для отправки текста отзыва
                    this.$buttonFeedback = this.$feedback.find('[data-role="create-feedback"]');
                    // кнопка для отправки номера телефона
                    this.$buttonCallback = this.$callback.find('[data-role="create-callback"]');
                    // кнопка для возврата на предыдущий экран формы с полями ввода
                    this.$buttonRetry = this.$fail.find('[data-role="try-again"]');
                }

                // инициализировать форму начальным состоянием

            }, {
                key: "initForm",
                value: function initForm() {
                    this.$text.val(''); // номер телефона не сбрасывать, в отличие от текста отзыва
                    this.showSection(this.$feedback);
                }

                // отправить номер телефона

            }, {
                key: "sendCallback",
                value: function sendCallback() {
                    if (!this.validateCallback()) {
                        return;
                    }
                    this.sendRequest('/customer-feedback/create-callback');
                }

                // отправить текст отзыва

            }, {
                key: "sendFeedback",
                value: function sendFeedback() {
                    if (!this.validateFeedback()) {
                        return;
                    }
                    this.sendRequest('/customer-feedback/create-feedback');
                }

                // отправить запрос на сервер

            }, {
                key: "sendRequest",
                value: function sendRequest(url) {
                    var _this = this;

                    $.ajax(url, {
                        method: 'post',
                        data: this.$form.serialize(),
                        beforeSend: function beforeSend(jqXHR, settings) {
                            _this.freezeForm();
                        },
                        error: function error(jqXHR, textStatus, errorThrown) {
                            //this.log(`%cОшибка при запросе: ${textStatus} - ${errorThrown}`, 'color: red; font-size: 22px;');
                            _this.showFail();
                        },
                        success: function success(_ref) {
                            var _success = _ref.success,
                                message = _ref.message,
                                data = _ref.data;

                            if (!_success) {
                                //this.log(`%cОшибка при ответе: ${message}`, 'color: red; font-size: 22px;', data);
                                _this.showFail();
                                return;
                            }

                            // если до этого был показан экран с отзывом, то сразу показать экран с номером телефона
                            if (_this.$currentFieldsetSection === _this.$feedback) {
                                _this.showSection(_this.$callback);
                            } else {
                                _this.showSuccess();
                            }
                            var conversion = window.tracking.formConversion;
                            conversion.markSearchFeedback(_this.$wrapper[0], true);
                        },
                        complete: function complete(jqXHR, textStatus) {
                            _this.unfreezeForm();
                        }
                    });
                }

                // отобразить экран формы с отрицательным результатом сабмита

            }, {
                key: "showFail",
                value: function showFail() {
                    this.showSection(this.$fail);
                }

                // отобразить экран формы

            }, {
                key: "showSection",
                value: function showSection($section) {
                    if (!$section) {
                        //this.log('%cНе указан экран формы для отображения', 'color: orange; font-size: 22px;');
                        return;
                    }

                    // сбросить таймер для промежуточного показа экрана успеха
                    if (this.successTimerId) {
                        window.clearTimeout(this.successTimerId);
                        this.successTimerId = 0;
                    }

                    var cssClassFail = 'state-fail',
                        cssClassSuccess = 'state-success';

                    var cssClassCurrent = 'section-current';

                    this.$wrapper.removeClass([cssClassFail, cssClassSuccess].join(' '));
                    switch ($section) {
                        case this.$fail:
                            this.$wrapper.addClass(cssClassFail);
                            break;
                        case this.$success:
                            this.$wrapper.addClass(cssClassSuccess);
                            /*
                            // если до этого был показан экран с отзывом, то немного погодя показать экран с номером телефона
                            if (this.$currentFieldsetSection === this.$feedback) {
                                this.successTimerId = window.setTimeout(() => {
                                    this.showSection(this.$callback);
                                }, 2000);
                            }
                            */
                            break;
                        case this.$feedback:
                        case this.$callback:
                            // запомнить текущий экран с полями ввода, чтобы иметь возможность вернуться к нему при ошибке
                            this.$currentFieldsetSection = $section;
                    }

                    this.$sections.removeClass(cssClassCurrent);
                    $section.addClass(cssClassCurrent);
                }

                // отобразить экран формы с положительным результатом сабмита

            }, {
                key: "showSuccess",
                value: function showSuccess() {
                    this.showSection(this.$success);
                }
            }, {
                key: "unfreezeForm",
                value: function unfreezeForm() {
                    this.$form.removeClass('state-loading').find(':input, :button').removeAttr('disabled');
                }

                // валидировать номер телефона

            }, {
                key: "validateCallback",
                value: function validateCallback() {
                    return this.validateTextInput(this.$phone, function (value) {
                        return (/^\d{10}$/.test(value)
                        );
                    });
                }

                // валидировать текст отзыва

            }, {
                key: "validateFeedback",
                value: function validateFeedback() {
                    return this.validateTextInput(this.$text, function (value) {
                        return value.length > 0;
                    });
                }

                // валидировать текстовое поле

            }, {
                key: "validateTextInput",
                value: function validateTextInput($textInput, validator) {
                    var trim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                    if (!$textInput || typeof validator !== 'function') {
                        return false;
                    }

                    // иногда красную границу нужно выводить не на самом текстовом инпуте, а на родительском контейнере
                    var cssClassFormInput = '.input-control.control-text';

                    var value = trim ? $.trim($textInput.val()) : $textInput.val();
                    if (trim) {
                        $textInput.val(value);
                    }

                    var isValid = validator(value);
                    if (isValid) {
                        $textInput.closest(cssClassFormInput).removeClass('has-error');
                    } else {
                        $textInput.focus().closest(cssClassFormInput).addClass('has-error');
                    }

                    return isValid;
                }

                // логировать для отладки

            }, {
                key: "log",
                value: function log() {
                    var _console;

                    if (!window.app.debug) {
                        return;
                    }
                    (_console = console).log.apply(_console, arguments);
                }
            }]);

            return CustomerFeedbackForm;
        }();

        $(function () {
            $('.customer-feedback').each(function (i, e) {
                new CustomerFeedbackForm(e);
            });
        });
    }, {}] }, {}, [1]);